import normalizer from '@cordel/helpers/form/schema';

// eslint-disable-next-line import/no-extraneous-dependencies
import { SORT_METHODS } from '@/_CRUDL/helpers/data/sort';

import {
  FILTERS,
  ALWAYS_VISIBLE,
} from './sections';

import {
  SEARCH,
  STORE_ID,
  SORT,
  ACTIVE,
} from './fields';

export default function schema() {
  return normalizer({
    sections: {
      [FILTERS]: {},
    },

    fields: {
      [SEARCH]: {
        section: FILTERS,
        subsection: ALWAYS_VISIBLE,
        type: 'input',
        label: 'Pesquisar',
        labelless: true,
        placeholder: 'Pesquisar...',
        size: 12,
        icon: 'search',
      },
      [STORE_ID]: {
        section: FILTERS,
        type: 'select',
        label: 'Loja',
        labelless: true,
        placeholder: 'Filtrar por loja',
        size: 4,
        searchable: 'stores',
      },
      [ACTIVE]: {
        section: FILTERS,
        type: 'select',
        label: 'Em estoque?',
        labelless: true,
        placeholder: 'Filtrar por status',
        size: 4,
        options: [{
          label: 'Todos os veículos',
          value: '',
        }, {
          label: 'Ativos no estoque',
          value: 'true',
        }, {
          label: 'Retirados do estoque',
          value: 'false',
        }],
      },
      [SORT]: {
        section: FILTERS,
        type: 'select',
        label: 'Ordenação',
        labelless: true,
        placeholder: 'Ordenação dos resultados',
        size: 4,
        options: Object.values(SORT_METHODS),
        value: SORT_METHODS.created_at_desc.value,
      },
    },
  });
}
